// --- Other Constants ---
export const POLLING_INTERVAL = 7000; // 7 seconds for polling updates
// Mock names, likely used as placeholders in the UI
export const MOCK_OPERATOR_NAME = "Support Agent";
export const MOCK_BOT_NAME = "ChatBot";
